import { Respuesta } from './../entities/respuesta.entity';
import { PrimerAcceso } from './../entities/primerAcceso.entity';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { Router } from '@angular/router';
import { AlertBoxComponent } from '../shared/alertbox.component';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changePassword.component.html'
})

export class ChangePasswordComponent implements OnInit {
  public user: PrimerAcceso = new PrimerAcceso();
  public messageCabecera: string;
  public typeException: number;
  public messageComplet: string;
  public resultado: Respuesta;
  public nombre: string;
  public login: string;
  public oldPassword: string;
  public password: string;
  public passwordConfirm: string;
  public inputErrorPasswordBlanco: boolean;
  public inputErrorPasswordNoCoincide: boolean;
  public inputErrorOldPasswordBlanco: boolean;

  constructor(private userService: UserService, private sessionService: SessionService, private router: Router) { }

  ngOnInit() {
    // if (this.sessionService.isAuthenicated === true) {
    if (this.sessionService.pendingChangePass) {
      this.login = this.sessionService.login;
      this.nombre = this.sessionService.nombre;
    } else {
      this.router.navigate(['/public/login']);
    }
  }

  public firstAccess(): void {
    this.typeException = -1;
    this.user.Login = this.sessionService.login;
    this.user.Nombre = this.sessionService.nombre;
    this.inputErrorPasswordNoCoincide = true;
    this.inputErrorPasswordBlanco = false;
    this.inputErrorOldPasswordBlanco = false;
    this.password = this.password === undefined ? '' : this.password;
    this.passwordConfirm = this.passwordConfirm === undefined ? '' : this.passwordConfirm;
    this.oldPassword = this.oldPassword === undefined ? '' : this.oldPassword;
    if (this.oldPassword === '') {
      this.inputErrorOldPasswordBlanco = true;
    }
    if (this.password === this.passwordConfirm) {
      this.inputErrorPasswordNoCoincide = false;
      this.inputErrorPasswordBlanco = true;
      if (this.password !== '') {
        this.inputErrorPasswordBlanco = false;
        if (this.oldPassword !== '') {
          this.user.OldPassword = this.oldPassword;
          this.user.Password = this.password;
          this.user.PasswordRepetir = this.passwordConfirm;
          this.userService.FirstAccess(this.sessionService.explotacion, this.user)
            .then(
              () => this.firstAccessOnSuccess(),
              response => this.firstAccessOnError(response)
            );
        }
      }
    }
  }

  private firstAccessOnSuccess(): void {
    this.messageCabecera = 'Cambio de clave';
    this.typeException = 2;
    this.messageComplet = 'La contraseña ha sido actualizada correctamente';
    AlertBoxComponent.changeMensaje.next(this.typeException);
    this.clearInputs();
    this.sessionService.isAuthenicated = true;
    this.router.navigate(['/home/home']);
  }

  private firstAccessOnError(response: any): void {
    this.resultado = response;
    this.messageCabecera = 'Cambio de clave';
    if (this.resultado.Ex !== undefined) {
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.messageComplet = 'Se ha producido un error al intentar actualizar la clave';
      this.typeException = 1;
    }
    AlertBoxComponent.changeMensaje.next(this.typeException);
  }

  public clearInputs() {
    this.inputErrorOldPasswordBlanco = false;
    this.inputErrorPasswordBlanco = false;
    this.inputErrorPasswordNoCoincide = false;
    this.oldPassword = '';
    this.password = '';
    this.passwordConfirm = '';
  }
}
